import { render } from "./contact-info.vue?vue&type=template&id=434d81f0&scoped=true"
import script from "./contact-info.vue?vue&type=script&lang=js"
export * from "./contact-info.vue?vue&type=script&lang=js"

import "./contact-info.vue?vue&type=style&index=0&id=434d81f0&lang=scss&scoped=true"

import exportComponent from "/home/gebruiker/www/fresh/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-434d81f0"]])

export default __exports__